/**
 * 升级为内测用户弹窗组件
 */
import React, { useState } from 'react';
import { Modal, Input, Button, Alert, Space } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import { useUser } from '../contexts/UserContext';

const UpgradeModal = ({ visible, onClose }) => {
  const { upgrade, refreshUser } = useUser();
  const [accessCode, setAccessCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleUpgrade = async () => {
    if (!accessCode.trim()) {
      setError('请输入内测码');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const success = await upgrade(accessCode);
      if (success) {
        await refreshUser();
        setAccessCode('');
        onClose();
      } else {
        setError('内测码不正确，请重试');
      }
    } catch (err) {
      setError('升级失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setAccessCode('');
    setError(null);
    onClose();
  };

  return (
    <Modal
      title={
        <Space>
          <CrownOutlined style={{ color: '#faad14' }} />
          <span>升级成为内测用户</span>
        </Space>
      }
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          取消
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleUpgrade}
        >
          确认
        </Button>,
      ]}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <div>
          <p>请输入内测码以升级为内测用户：</p>
          <p style={{ color: '#666', fontSize: '12px' }}>
            升级后，您将无需上传 API Key，系统将自动使用默认配置。
          </p>
        </div>

        <Input.Password
          placeholder="请输入内测码"
          value={accessCode}
          onChange={(e) => {
            setAccessCode(e.target.value);
            setError(null);
          }}
          onPressEnter={handleUpgrade}
          size="large"
        />

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            closable
            onClose={() => setError(null)}
          />
        )}
      </Space>
    </Modal>
  );
};

export default UpgradeModal;

